import { lighten } from 'ggApp/utils/color/lighten';
import { transition } from 'ggApp/utils/mixins/transition';
import styled, { css, keyframes } from 'styled-components';
import omitProps from 'ggApp/utils/omitProps';

export const Root = styled.div`
    position: relative;
    overflow: hidden;
    ${transition('all', 'medium-desktop', 'standard')};
`;

const ShimmerEffect = keyframes`
  0% {
    transform: translateX(0%)
  }

  40%, 100% {
    transform: translateX(500%)
  }
`;

const ShimmerEffectRule = css(['', ' ;'], ShimmerEffect);

export const Shimmer = styled(omitProps('loading', 'animationDelay', 'accentColor', 'entered')('div'))`
    position: absolute;
    top: 0;
    width: 100%;
    bottom: 0;
    visibility: visible;
    opacity: 1;
    will-change: opacity, visibility;
    ${transition('all', 'medium-desktop', 'standard')};
    transition-delay: 0.2s;
    ${({ accentColor }) => {
        return css`
            background: ${accentColor || '#ededed'};
        `;
    }};
    ${({ loading }) => !loading
        && css`
            visibility: hidden;
            opacity: 0;
        `};
    display: inline-block;

    &:before {
        content: '';
        display: block;
        position: absolute;
        top: 0;
        width: 100%;
        left: -100%;
        bottom: 0;
        background-repeat: no-repeat;
        background-size: 100% 100%;
        animation-delay: ${({ animationDelay }) => animationDelay}s;
        animation-duration: 2s;
        animation-fill-mode: forwards;
        animation-iteration-count: infinite;
        animation-timing-function: ease-in-out;
        transform: translate3d(0, 0, 0);
        will-change: transform;
        ${({ loading, entered }) => (loading && entered
        ? css`
                      animation-name: ${ShimmerEffectRule};
                  `
        : css`
                      visibility: hidden;
                      opacity: 0;
                  `)};
        ${({ accentColor }) => {
        const gradientColor = accentColor || '#f1f1f1';
        const gradientLightenMultiplier = accentColor ? 0.1 : 0.035;
        return css`
                background-image: linear-gradient(
                    90deg,
                    ${gradientColor},
                    ${lighten(gradientLightenMultiplier, gradientColor)},
                    ${gradientColor}
                );
            `;
    }};
    }
`;

export const ImageContainer = styled.div`
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    display: flex;
    justify-content: center;
    align-items: center;
    bottom: 0;
    flex-direction: column;
    max-height: inherit;
    max-width: inherit;
    > img {
        max-width: 100%;
        max-height: 100%;
        width: auto;
        height: auto;
        &:not([src]) {
            height: 100%;
            width: 100%;
        }
    }
`;
